module.exports = __webpack_public_path__ + "static/media/R-330XLHD.3b7ce122.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-330XLHD.png
// module id = 2105
// module chunks = 0